import { render, staticRenderFns } from "./DismissalBigScreenAuto.vue?vue&type=template&id=f062d79a&scoped=true"
import script from "./DismissalBigScreenAuto.vue?vue&type=script&lang=js"
export * from "./DismissalBigScreenAuto.vue?vue&type=script&lang=js"
import style0 from "./DismissalBigScreenAuto.vue?vue&type=style&index=0&id=f062d79a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f062d79a",
  null
  
)

export default component.exports